import { Component } from "@angular/core";

@Component({
    templateUrl: "./club-profile-submenu.component.html"
})
export class ClubProfileSubmenuComponent {

}